import React, { useContext, useEffect } from 'react';
import { Context } from '../../../context/global-data-provider';

import './rates-style.css';
import { Helmet } from 'react-helmet';

function Rates() {
  const { setCurrentRoute, options } = useContext(Context);

  useEffect(() => {
    setCurrentRoute('/rates');
  });

  return (
    <div className="rates f-grow-1 wh-100 align-items-center justify-content-center">
      <Helmet>
        <title>{options.title} • نرخ طلا و سکه</title>
      </Helmet>

      <div className="card">
        <div className="card-header all-center border-none">
          <h2 className="title">قیمت طلا</h2>
        </div>

        <div className="card-body colored-rows">
          <div className="row-item p-8p px-16p mb-2p f-row justify-content-between">
            <span className="font-size-5-5">انس طلا</span>
            <span className="font-size-5-5">{options.rate_ounces_of_gold}</span>
          </div>

          <div className="row-item p-8p px-16p mb-2p f-row justify-content-between">
            <span className="font-size-5-5">مظنه تهران</span>
            <span className="font-size-5-5">{options.rate_quote_of_tehran}</span>
          </div>

          <div className="row-item p-8p px-16p mb-2p f-row justify-content-between">
            <span className="font-size-5-5">طلای ۱۸‌عیار</span>
            <span className="font-size-5-5">{options.rate_18_carat_gold}</span>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header all-center border-none">
          <h2 className="title">قیمت سکه</h2>
        </div>

        <div className="card-body colored-rows">
          <div className="row-item p-8p px-16p mb-2p f-row justify-content-between">
            <span className="font-size-5-5">تمام سکه</span>
            <span className="font-size-5-5">{options.rate_new_design_coin}</span>
          </div>

          <div className="row-item p-8p px-16p mb-2p f-row justify-content-between">
            <span className="font-size-5-5">نیم سکه</span>
            <span className="font-size-5-5">{options.rate_half_coin}</span>
          </div>

          <div className="row-item p-8p px-16p mb-2p f-row justify-content-between">
            <span className="font-size-5-5">ربع سکه</span>
            <span className="font-size-5-5">{options.rate_quarter_coin}</span>
          </div>

          <div className="row-item p-8p px-16p mb-2p f-row justify-content-between">
            <span className="font-size-5-5">سکه یک گرمی</span>
            <span className="font-size-5-5">{options.rate_1_gram_coin}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Rates;
